// @ts-nocheck
import React, { useState, useEffect } from 'react';
import { withRouter } from '../../router-compat';
import { inject, observer } from "../../stores/mobx-compat";

import Sidebar from './Sidebar';
import Topbar from './Topbar';
import Drawer from '../ui/Drawer';
import CaptureLogo from '../ui/CaptureLogo';

const DashboardLayout = ({ routeConfigs, children, store, location }) => {
  const { mobile } = store.ui;
  const [mobileNav, setMobileNav] = useState(false);

  useEffect(() => { setMobileNav(false); }, [location.pathname]);

  return (
    <div
      className="mov-app"
      style={{
        display: 'grid',
        gridTemplateColumns: mobile ? '1fr' : '240px 1fr',
        minHeight: '100vh',
      }}
    >
      {!mobile && <Sidebar routeConfigs={routeConfigs} />}
      <main style={{ minWidth: 0 }}>
        <Topbar routeConfigs={routeConfigs} onMobileMenu={() => setMobileNav(true)} />
        <div
          style={{
            padding: mobile ? '20px 16px 60px' : '28px 32px 64px',
            maxWidth: 1480,
            margin: '0 auto',
          }}
        >
          {children}
        </div>
      </main>

      {mobile && (
        <Drawer
          open={mobileNav}
          onClose={() => setMobileNav(false)}
          side="left"
          width={264}
          title={<CaptureLogo style={{ width: 110 }} />}
        >
          <Sidebar routeConfigs={routeConfigs} onNavigate={() => setMobileNav(false)} />
        </Drawer>
      )}
    </div>
  );
};

export default withRouter(inject('store')(observer(DashboardLayout)));
